import React from 'react';
import { usePageSEO } from '../hooks/usePageSEO';
import { breadcrumbSchema } from '../utils/structuredData';
export function TeamPage() {
  usePageSEO({
    canonical: '/team',
    keywords: 'Design Flow Digitals team, Shopify developers, ecommerce experts, Shopify agency team',
    jsonLd: breadcrumbSchema([{
      name: 'Home',
      path: '/'
    }, {
      name: 'Team',
      path: '/team'
    }]),
    title: 'Team | Design Flow Digitals',
    description: 'Meet the team behind Design Flow Digitals. Shopify developers, designers, and strategists dedicated to building premium ecommerce experiences.'
  });
  return <div className="pt-32 pb-20" data-id="element-1591">
      <section className="px-6 md:px-12 max-w-5xl mx-auto text-center mb-24" data-id="element-1592">
        <h1 className="text-5xl md:text-7xl font-bold mb-8" data-id="element-1593">Meet the Team</h1>
        <p className="text-xl md:text-2xl text-gray-400 leading-relaxed" data-id="element-1594">
          Design Flow Digitals is powered by a team of designers, developers,
          and ecommerce specialists.
        </p>
      </section>

      <section className="section-padding bg-black border-y border-white/5" data-id="element-1595">
        <div className="max-w-4xl mx-auto text-center" data-id="element-1596">
          <h2 className="text-3xl font-bold mb-12" data-id="element-1597">Our Collective Expertise</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-1598">
            {['Shopify Development', 'UX/UI Design', 'Ecommerce Growth', 'Performance Engineering'].map((skill, i) => <div key={i} className="glass-card p-6 border-white/10" data-id="element-1599">
                <p className="font-medium text-white" data-id="element-1600">{skill}</p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="section-padding" data-id="element-1601">
        <div className="max-w-4xl mx-auto" data-id="element-1602">
          <h2 className="text-sm font-bold text-[#D4AF37] uppercase tracking-widest mb-12 text-center" data-id="element-1603">
            The People Behind the Work
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1604">
            {/* Pankaj Maurya */}
            <div className="glass-card p-6 border-white/10 text-center hover:border-[#D4AF37]/30 transition-colors duration-300" data-id="element-1605">
              <div className="w-28 h-28 mx-auto rounded-full border-2 border-[#D4AF37]/30 overflow-hidden mb-5" data-id="element-1606">
                <img src="https://cdn.magicpatterns.com/uploads/mGfabHy4m1VsnCVj3nADJ1/Pankaj_Template_Profile_(1).png" alt="Pankaj Maurya" className="w-full h-full object-cover object-top" data-id="element-1607" />
              </div>
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-1608">
                Pankaj Maurya
              </h3>
              <p className="text-[#D4AF37] text-sm font-medium mb-4" data-id="element-1609">Founder</p>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1610">
                Founder of Design Flow Digitals. Full-stack developer with a
                Master's in Commerce, bringing deep ecommerce expertise and
                technical skill to every project. Over 1,000 Shopify stores
                delivered for global brands and entrepreneurs.
              </p>
            </div>

            {/* Samuel Masih */}
            <div className="glass-card p-6 border-white/10 text-center hover:border-[#D4AF37]/30 transition-colors duration-300" data-id="element-1611">
              <div className="w-28 h-28 mx-auto rounded-full border-2 border-[#D4AF37]/30 overflow-hidden mb-5" data-id="element-1612">
                <img src="https://cdn.magicpatterns.com/uploads/9gTnZstt2EDzKocCdbCK3V/1718263422794.jpg" alt="Samuel Masih" className="w-full h-full object-cover object-top" data-id="element-1613" />
              </div>
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-1614">
                Samuel Masih
              </h3>
              <p className="text-[#D4AF37] text-sm font-medium mb-4" data-id="element-1615">
                Lead Developer
              </p>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1616">
                Full-stack Software Engineer specializing in the MERN stack,
                React, Next.js, and scalable web applications. Driven by
                curiosity and a deep analytical mindset, Samuel delivers
                end-to-end solutions from clean UI design to robust backend
                systems.
              </p>
            </div>

            {/* Saloni Gupta */}
            <div className="glass-card p-6 border-white/10 text-center hover:border-[#D4AF37]/30 transition-colors duration-300" data-id="element-1617">
              <div className="w-28 h-28 mx-auto rounded-full bg-gradient-to-br from-gray-800 to-black border-2 border-[#D4AF37]/30 flex items-center justify-center overflow-hidden relative mb-5" data-id="element-1618">
                <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 mix-blend-overlay" data-id="element-1619" />
                <span className="text-3xl font-bold text-white/20" data-id="element-1620">SG</span>
              </div>
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-1621">
                Saloni Gupta
              </h3>
              <p className="text-[#D4AF37] text-sm font-medium mb-4" data-id="element-1622">
                Performance Engineer
              </p>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1623">
                Combines performance engineering with UX/UI design expertise to
                craft fast, beautiful ecommerce experiences that convert
                visitors into customers.
              </p>
            </div>

            {/* Neeraj Kushwaha */}
            <div className="glass-card p-6 border-white/10 text-center hover:border-[#D4AF37]/30 transition-colors duration-300" data-id="element-1624">
              <div className="w-28 h-28 mx-auto rounded-full bg-gradient-to-br from-gray-800 to-black border-2 border-[#D4AF37]/30 flex items-center justify-center overflow-hidden relative mb-5" data-id="element-1625">
                <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 mix-blend-overlay" data-id="element-1626" />
                <span className="text-3xl font-bold text-white/20" data-id="element-1627">NK</span>
              </div>
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-1628">
                Neeraj Kushwaha
              </h3>
              <p className="text-[#D4AF37] text-sm font-medium mb-4" data-id="element-1629">
                Marketing Lead
              </p>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1630">
                Leads marketing strategy and brand growth, turning standout
                Shopify work into measurable demand and helping the right
                merchants discover Design Flow Digitals.
              </p>
            </div>

            {/* Upasana Choubey */}
            <div className="glass-card p-6 border-white/10 text-center hover:border-[#D4AF37]/30 transition-colors duration-300" data-id="element-1631">
              <div className="w-28 h-28 mx-auto rounded-full bg-gradient-to-br from-gray-800 to-black border-2 border-[#D4AF37]/30 flex items-center justify-center overflow-hidden relative mb-5" data-id="element-1632">
                <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 mix-blend-overlay" data-id="element-1633" />
                <span className="text-3xl font-bold text-white/20" data-id="element-1634">UC</span>
              </div>
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-1635">
                Upasana Choubey
              </h3>
              <p className="text-[#D4AF37] text-sm font-medium mb-4" data-id="element-1636">
                Social Media Manager
              </p>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1637">
                Builds the social presence that keeps the agency top of mind,
                crafting content and campaigns that showcase client wins and
                grow an engaged community.
              </p>
            </div>

            {/* Akash Tomar */}
            <div className="glass-card p-6 border-white/10 text-center hover:border-[#D4AF37]/30 transition-colors duration-300" data-id="element-1638">
              <div className="w-28 h-28 mx-auto rounded-full bg-gradient-to-br from-gray-800 to-black border-2 border-[#D4AF37]/30 flex items-center justify-center overflow-hidden relative mb-5" data-id="element-1639">
                <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 mix-blend-overlay" data-id="element-1640" />
                <span className="text-3xl font-bold text-white/20" data-id="element-1641">AT</span>
              </div>
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-1642">Akash Tomar</h3>
              <p className="text-[#D4AF37] text-sm font-medium mb-4" data-id="element-1643">
                Full Stack Developer
              </p>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1644">
                Builds robust Shopify storefronts and custom app features from
                front to back, delivering clean, scalable code that keeps stores
                fast and reliable.
              </p>
            </div>

            {/* Abhishek Yadav */}
            <div className="glass-card p-6 border-white/10 text-center hover:border-[#D4AF37]/30 transition-colors duration-300" data-id="element-1645">
              <div className="w-28 h-28 mx-auto rounded-full bg-gradient-to-br from-gray-800 to-black border-2 border-[#D4AF37]/30 flex items-center justify-center overflow-hidden relative mb-5" data-id="element-1646">
                <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 mix-blend-overlay" data-id="element-1647" />
                <span className="text-3xl font-bold text-white/20" data-id="element-1648">AY</span>
              </div>
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-1649">
                Abhishek Yadav
              </h3>
              <p className="text-[#D4AF37] text-sm font-medium mb-4" data-id="element-1650">
                Graphics Designer
              </p>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1651">
                Shapes the visual identity of every project, designing the
                graphics, store visuals, and brand assets that give each
                ecommerce experience a premium, polished look.
              </p>
            </div>

            {/* Join Us */}
            <div className="glass-card p-6 border-white/10 text-center hover:border-[#D4AF37]/30 transition-colors duration-300 flex flex-col items-center justify-center" data-id="element-1652">
              <div className="w-28 h-28 mx-auto rounded-full bg-gradient-to-br from-gray-800 to-black border-2 border-dashed border-[#D4AF37]/30 flex items-center justify-center overflow-hidden relative mb-5" data-id="element-1653">
                <span className="text-3xl text-[#D4AF37]/40" data-id="element-1654">+</span>
              </div>
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-1655">
                Join Our Team
              </h3>
              <p className="text-[#D4AF37] text-sm font-medium mb-4" data-id="element-1656">
                We're Hiring
              </p>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1657">
                We're always looking for talented developers and designers
                passionate about ecommerce.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}